import { Injectable } from '@angular/core';
import { QueryColumn, QueryColumnSortOrder } from '@barthauer/abc/core/data';
import { DataService, ObjectKeys } from '../../services/data.service';
import { Observable } from 'rxjs';
import { PersonStatus } from '../../models/enumeration-list.model';

@Injectable()
export class CompanySelectionService {
    public readonly addressPersonColumns: QueryColumn[] = [
        this.dataService.coreDataService.createQueryColumn("Id", "Id"),
        this.dataService.coreDataService.createQueryColumn("Position", "Position"),
        this.dataService.coreDataService.createQueryColumn("ParentId", "ParentId"),
        this.dataService.coreDataService.createQueryColumn("Address.Name", "Name"),
        this.dataService.coreDataService.createQueryColumn("Address.Street", "Street"),
        this.dataService.coreDataService.createQueryColumn("Address.HouseNumber", "HouseNumber"),
        this.dataService.coreDataService.createQueryColumn("Address.ZIP", "ZIP"),
        this.dataService.coreDataService.createQueryColumn("Address.City", "City"),
        this.dataService.coreDataService.createQueryColumn("Address.Country", "Country"),
        this.dataService.coreDataService.createQueryColumn("Address.EMail", "EMail"),
        this.dataService.coreDataService.createQueryColumn("Address.Phone", "Phone"),
        this.dataService.coreDataService.createQueryColumn("Address.Phone2", "Phone2"),
        this.dataService.coreDataService.createQueryColumn("Address.MatchCode", "MatchCode"),
        this.dataService.coreDataService.createQueryColumn("SysDateUpdate", "SysDateUpdate", QueryColumnSortOrder.Descending),
        {

            Name: "Object",
            OPath: "Max(Address.Documents[Kind = 'IMAGE'].Object)",
            Format: "Base64Image[180x80]",
        },
    ];

    constructor(private dataService: DataService) { }

    public prepareCompanyList(id?: string, extraOPath?: string): Observable<any> {
        const profileId = sessionStorage.getItem("profileId");
        let filter = `IdRefPerson='${profileId}' AND Status <> '${PersonStatus.ARCHIVED}'`;
        if (extraOPath?.trim()) {
            filter += ` And ${extraOPath.trim()}`;
        }

        return this.dataService.readObjects(
            ObjectKeys.ADDRESSPERSON,
            this.addressPersonColumns,
            filter
        );
    }


}
